
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pricing",
      function () {
        return require("private-next-pages/signature/pricing/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/pricing"])
      });
    }
  